import { render } from "./TheHumanRescources.vue?vue&type=template&id=070f96de&scoped=true&lang=true"
import script from "./TheHumanRescources.vue?vue&type=script&lang=js"
export * from "./TheHumanRescources.vue?vue&type=script&lang=js"

import "./TheHumanRescources.vue?vue&type=style&index=0&id=070f96de&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070f96de"]])

export default __exports__